import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "@/helpers/axios";
import type { ApiResponse } from "@/helpers/axios";
import type { AccountAdminDetails } from "../_types/account-admin-details.types";

export const useAccountAdminDetailsQuery = (accountId: string | null, enabled: boolean) => {
  return useQuery({
    queryKey: ["account-admin-details", accountId],
    queryFn: async (): Promise<AccountAdminDetails> => {
      const response = await axiosInstance.get<ApiResponse<AccountAdminDetails>>(
        `/v2/accounts/${accountId}/admin-details`
      );
      if (!response.data.data) {
        throw new Error(response.data.message || "Could not load account details");
      }
      return response.data.data;
    },
    enabled: Boolean(accountId && enabled),
  });
};
